import { useState, useMemo } from "react";

const allCities = [
  { name: "Albany", route: "/albany-ny", tagline: "Capital Region expedited passport services", highlights: ["NYS Capital coverage", "Serving Troy, Schenectady, Saratoga Springs"], badge: null, status: "live" },
  { name: "Amsterdam", route: "/amsterdam-ny", tagline: "Mohawk Valley expedited passport services", highlights: ["Montgomery County coverage", "Serving Fonda, Fort Plain, Canajoharie, Gloversville"], badge: null, status: "live" },
  { name: "Ballston Spa", route: "/ballston-spa", tagline: "Saratoga County expedited passport services", highlights: ["Saratoga County coverage", "Serving Saratoga Springs, Malta, Clifton Park"], badge: null, status: "live" },
  { name: "Bay Shore", route: "/bay-shore", tagline: "South Shore Suffolk County passport processing", highlights: ["Bay Shore area coverage", "Serving Islip, Brentwood, West Babylon"], badge: null, status: "live" },
  { name: "Binghamton", route: "/binghamton", tagline: "Southern Tier expedited passport services", highlights: ["Broome County coverage", "Serving Johnson City, Vestal, Endicott"], badge: null, status: "live" },
  { name: "Brooklyn", route: "/brooklyn", tagline: "Kings County expedited passport processing", highlights: ["All Brooklyn neighborhoods", "Serving Williamsburg, Park Slope, Bay Ridge"], badge: null, status: "live" },
  { name: "Buffalo", route: "/buffalo", tagline: "Western New York's trusted expedited passport hub", highlights: ["Erie County coverage", "Serving Niagara Falls, Amherst, Cheektowaga"], badge: "Most Popular", status: "live" },
  { name: "Commack", route: "/commack", tagline: "Central Suffolk County passport services", highlights: ["Commack area coverage", "Serving Smithtown, Hauppauge, Dix Hills"], badge: null, status: "live" },
  { name: "Catskill", route: "/catskill", tagline: "Greene County & Catskill Mountains expedited passport services", highlights: ["Catskill Mountain gateway coverage", "Serving Cairo, Hunter, Windham, Tannersville"], badge: null, status: "live" },
  { name: "Chatham", route: "/chatham", tagline: "Columbia County expedited passport services near the Massachusetts border", highlights: ["Chatham area coverage", "Serving Ghent, Philmont, East Chatham, Kinderhook"], badge: null, status: "live" },
  { name: "Corning", route: "/corning", tagline: "Crystal City expedited passport services", highlights: ["Steuben County coverage", "Serving Elmira, Watkins Glen, Hammondsport"], badge: null, status: "live" },
  { name: "Elmira", route: "/elmira", tagline: "Twin Tiers expedited passport services", highlights: ["Chemung County coverage", "Serving Corning, Horseheads"], badge: null, status: "live" },
  { name: "Long Island", route: "/long-island", tagline: "Nassau & Suffolk County expedited passport services", highlights: ["All of Nassau and Suffolk County", "Serving Hempstead, Islip, Huntington, Smithtown"], badge: null, status: "live" },
  { name: "Glens Falls", route: "/glens-falls", tagline: "Adirondack gateway expedited passport services", highlights: ["Warren County coverage", "Serving Queensbury, Hudson Falls, Lake George"], badge: null, status: "live" },
  { name: "Gloversville", route: "/gloversville", tagline: "Fulton County expedited passport services", highlights: ["Fulton County coverage", "Serving Johnstown, Broadalbin, Mayfield, Northville"], badge: null, status: "live" },
  { name: "Hicksville", route: "/hicksville", tagline: "Central Nassau County passport services", highlights: ["Hicksville area coverage", "Serving Levittown, Bethpage, Plainview"], badge: null, status: "live" },
  { name: "Hudson", route: "/hudson-ny", tagline: "Columbia County expedited passport services", highlights: ["Columbia County coverage", "Serving Kinderhook, Chatham, Ghent, Claverack"], badge: null, status: "live" },
  { name: "Huntington", route: "/huntington", tagline: "North Shore Suffolk County passport services", highlights: ["Huntington area coverage", "Serving Northport, Commack, Dix Hills"], badge: null, status: "live" },
  { name: "Hyde Park", route: "/hyde-park", tagline: "FDR country expedited passport services", highlights: ["Dutchess County coverage", "Serving Rhinebeck, Poughkeepsie, Staatsburg"], badge: null, status: "live" },
  { name: "Islip", route: "/islip", tagline: "South Shore Suffolk County passport processing", highlights: ["Islip area coverage", "Serving Brentwood, Bay Shore, West Islip"], badge: null, status: "live" },
  { name: "Ithaca", route: "/ithaca", tagline: "Finger Lakes expedited passport services", highlights: ["Tompkins County coverage", "Serving Cornell University area, Cortland"], badge: null, status: "live" },
  { name: "Jamestown", route: "/jamestown", tagline: "Chautauqua County expedited passport services", highlights: ["Jamestown area coverage", "Serving Dunkirk, Fredonia"], badge: null, status: "live" },
  { name: "Kingston", route: "/kingston", tagline: "Hudson Valley expedited passport services", highlights: ["Ulster County coverage", "Serving New Paltz, Woodstock, Saugerties"], badge: null, status: "live" },
  { name: "Lake George", route: "/lake-george", tagline: "Adirondack resort region expedited passport services", highlights: ["Warren County coverage", "Serving Queensbury, Bolton Landing, Ticonderoga"], badge: null, status: "live" },
  { name: "Levittown", route: "/levittown", tagline: "Central Nassau County passport processing", highlights: ["Levittown area coverage", "Serving Wantagh, East Meadow, Hicksville"], badge: null, status: "live" },
  { name: "Malone", route: "/malone", tagline: "Franklin County expedited passport services", highlights: ["Northern Adirondacks coverage", "Serving Chateaugay, Fort Covington, Burke, Moira"], badge: null, status: "live" },
  { name: "Middletown", route: "/middletown-ny", tagline: "Orange County expedited passport services", highlights: ["Middletown area coverage", "Serving Newburgh, Monroe, Goshen"], badge: null, status: "live" },
  { name: "Mount Vernon", route: "/mount-vernon", tagline: "Westchester County expedited passport services", highlights: ["Mount Vernon area coverage", "Serving Yonkers, New Rochelle, Pelham"], badge: null, status: "live" },
  { name: "New Paltz", route: "/new-paltz", tagline: "SUNY New Paltz expedited passport services", highlights: ["Ulster County coverage", "Serving Kingston, Highland, Rosendale"], badge: null, status: "live" },
  { name: "New Rochelle", route: "/new-rochelle", tagline: "Westchester County expedited passport processing", highlights: ["New Rochelle area coverage", "Serving Pelham, Larchmont, Mamaroneck"], badge: null, status: "live" },
  { name: "New York City", route: "/new-york-city", tagline: "NYC's premier emergency and expedited passport service", highlights: ["All five boroughs covered", "24-hour processing available"], badge: "Most Popular", status: "live" },
  { name: "Newburgh", route: "/newburgh", tagline: "Orange County expedited passport services", highlights: ["Newburgh area coverage", "Serving Beacon, Cornwall, Montgomery"], badge: null, status: "live" },
  { name: "Niagara Falls", route: "/niagara-falls", tagline: "Niagara County expedited passport services", highlights: ["Niagara Falls area coverage", "Serving North Tonawanda, Lewiston"], badge: null, status: "live" },
  { name: "Ogdensburg", route: "/ogdensburg", tagline: "St. Lawrence County expedited passport services", highlights: ["St. Lawrence River coverage", "Serving Massena, Canton, Potsdam"], badge: null, status: "live" },
  { name: "Plattsburgh", route: "/plattsburgh", tagline: "Clinton County expedited passport services", highlights: ["North Country coverage", "Serving Peru, Champlain, Lake Champlain area"], badge: null, status: "live" },
  { name: "Poughkeepsie", route: "/poughkeepsie", tagline: "Dutchess County expedited passport processing", highlights: ["Poughkeepsie area coverage", "Serving Wappingers Falls, Hyde Park, Rhinebeck"], badge: null, status: "live" },
  { name: "Queens", route: "/queens", tagline: "Queens County expedited passport services", highlights: ["All Queens neighborhoods", "Serving JFK Airport area, Astoria, Flushing"], badge: null, status: "live" },
  { name: "Red Hook", route: "/red-hook", tagline: "Rural Dutchess County expedited passport services", highlights: ["Northern Dutchess County coverage", "Serving Rhinebeck, Tivoli, Annandale-on-Hudson"], badge: null, status: "live" },
  { name: "Rhinebeck", route: "/rhinebeck", tagline: "Hudson Valley wine country expedited passport services", highlights: ["Northern Dutchess County coverage", "Serving Red Hook, Tivoli, Hyde Park"], badge: null, status: "live" },
  { name: "Rochester", route: "/rochester", tagline: "Monroe County expedited passport services", highlights: ["Rochester area coverage", "Serving Brighton, Greece, Pittsford"], badge: null, status: "live" },
  { name: "Rome", route: "/rome-ny", tagline: "Oneida County expedited passport services", highlights: ["Oneida County coverage", "Serving Utica, New Hartford, Whitesboro, Oneida"], badge: null, status: "live" },
  { name: "Saratoga Springs", route: "/saratoga-springs", tagline: "Saratoga County expedited passport services", highlights: ["Saratoga Springs area", "Serving Ballston Spa, Malta, Glens Falls"], badge: null, status: "live" },
  { name: "Schenectady", route: "/schenectady", tagline: "Capital Region expedited passport processing", highlights: ["Schenectady area coverage", "Serving Rotterdam, Niskayuna, Scotia"], badge: null, status: "live" },
  { name: "Smithtown", route: "/smithtown", tagline: "North Shore Suffolk County passport services", highlights: ["Smithtown area coverage", "Serving Commack, Hauppauge, Kings Park"], badge: null, status: "live" },
  { name: "Staten Island", route: "/staten-island", tagline: "Richmond County expedited passport services", highlights: ["Staten Island area coverage", "Serving all Staten Island neighborhoods"], badge: null, status: "live" },
  { name: "Syracuse", route: "/syracuse", tagline: "Onondaga County expedited passport processing", highlights: ["Salt City coverage", "Serving Liverpool, DeWitt, Fayetteville"], badge: null, status: "live" },
  { name: "The Bronx", route: "/the-bronx", tagline: "Bronx County expedited passport services", highlights: ["All Bronx neighborhoods", "Serving Riverdale, Fordham, South Bronx"], badge: null, status: "live" },
  { name: "Troy", route: "/troy", tagline: "Capital Region expedited passport services", highlights: ["Troy area coverage", "Serving Rensselaer, East Greenbush, Watervliet"], badge: null, status: "live" },
  { name: "Tupper Lake", route: "/tupper-lake", tagline: "Central Adirondack expedited passport services", highlights: ["Franklin County coverage", "Serving Saranac Lake, Long Lake, Newcomb"], badge: null, status: "live" },
  { name: "Utica", route: "/utica", tagline: "Mohawk Valley expedited passport services", highlights: ["Utica area coverage", "Serving New Hartford, Whitesboro, Yorkville"], badge: null, status: "live" },
  { name: "Watertown", route: "/watertown", tagline: "Jefferson County expedited passport services", highlights: ["Thousand Islands coverage", "Serving Fort Drum, Carthage, Sackets Harbor"], badge: null, status: "live" },
  { name: "West Babylon", route: "/west-babylon", tagline: "South Shore Suffolk County passport processing", highlights: ["West Babylon area coverage", "Serving Lindenhurst, North Babylon, Babylon"], badge: null, status: "live" },
  { name: "White Plains", route: "/white-plains", tagline: "Westchester County expedited passport hub", highlights: ["White Plains area coverage", "Serving Harrison, Rye, Scarsdale"], badge: null, status: "live" },
  { name: "Yonkers", route: "/yonkers", tagline: "Westchester County expedited passport services", highlights: ["City of Hills coverage", "Serving Mount Vernon, New Rochelle, White Plains"], badge: null, status: "live" },
  { name: "Tarrytown", route: "/tarrytown", tagline: "Westchester County expedited passport services", highlights: ["Hudson River Valley coverage", "Serving Sleepy Hollow, White Plains, Ossining"], badge: null, status: "live" },
  { name: "Beacon", route: "/beacon", tagline: "Dutchess County expedited passport services", highlights: ["Beacon area coverage", "Serving Newburgh, Poughkeepsie, Fishkill"], badge: null, status: "live" },
  { name: "Fishkill", route: "/fishkill", tagline: "Dutchess County expedited passport services", highlights: ["Fishkill area coverage", "Serving Beacon, Poughkeepsie, Wappingers Falls"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function NewYorkCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            New York Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your New York Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">New York</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new New York locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}